import styled from 'styled-components';

export const BKJFormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
`;
